import {ApplicationStats, EntityStat, ImpactScore, TypedApiResponse} from 'src/types';
import {CODELOGIC_API_BASE_URL} from 'src/config';

import {axiosInstance} from './baseApi';

import {makeResourceFetchById} from './index';

export const getApplicationStats = makeResourceFetchById<ApplicationStats>({method: 'GET', path: 'statistics/application', after: 'stats'});

export async function getImpactScores(
    id: string,
    type: string,
    limit = 50,
): Promise<TypedApiResponse<Array<ImpactScore>>> {
  let endpoint = `${CODELOGIC_API_BASE_URL}/statistics/impactScore/`;

  endpoint = endpoint.concat(id);
  endpoint = endpoint.concat('/nodes');
  endpoint = endpoint.concat(`?type=${type}&limit=${limit}`);

  try {
    const response = await axiosInstance.get(endpoint, {withCredentials: true});

    return response.data;
  } catch (e) {
    return {
      status: 'error',
    };
  }
}

export async function getStatHistory(
    id: string,
    name: string,
    since: string,
    definitionId?: string,
): Promise<TypedApiResponse<Array<EntityStat>>> {
  const endpoint = `${CODELOGIC_API_BASE_URL}/statistics/${id}/${name}/history`;
  const params : any = {};

  params.since = since;
  if (definitionId) {
    params.definitionId = definitionId;
  }

  try {
    const response = await axiosInstance.get(endpoint, {withCredentials: true, params: params});

    return response.data;
  } catch (e) {
    return {
      status: 'error',
    };
  }
}
